import React from "react";
import MDTypography from "components/MDTypography";
import { Box } from "@mui/material";
import AuthenticationService from "../../modules/authentication/AuthenticationService";
import { formatCurrency } from "./currencyFormat";

function RupeeCell({ value, suffix }) {
  return (
    <Box display="flex" alignItems="center" py={0.5}>
      <MDTypography variant="caption" fontWeight="medium" color="text">
        {formatCurrency(value, AuthenticationService.getCurrencyConfig())}
      </MDTypography>
      {suffix && (
        <MDTypography variant="caption" fontWeight="medium" color="secondary">
          &nbsp;{suffix}
        </MDTypography>
      )}
    </Box>
  );
}

RupeeCell.defaultProps = {
  suffix: "",
};

export default RupeeCell;
